const config = {
  default: {
    name: "Trackmydoc",
    domainName: "trackmydoc.com",
    intractName: "Trackmydoc",
    intractEmail: "trackmydoc@gmail.com",
    firmType: "cpa",
  },
  "rv-client.9dottechno.com": {
    name: "RV Accounting",
    domainName: "9dottechno.com",
    logo: "/assets/logo/logo.png",
    favicon: "/assets/logo/favicon.png",
    intractName: "RV Accounting & Tax Services",
    intractEmail: "info@rvaccounting.ca",
    firmType: "cpa",
  }
};

const getSiteConfig = () => {
  const hostname = window.location.hostname;
  const matchedKey = Object.keys(config).find((key) => hostname.includes(key));
  return config[matchedKey] || config["default"];
};

const siteConfig = getSiteConfig();

export default siteConfig;
